export enum ProductCalculatedBy {
  AREA = 'AREA',
  VOLUME = 'VOLUME',
  TANK = 'TANK'
}

export enum SprayMode {
  TERRESTRIAL = 0,
  AERIAL = 1,
  COASTAL = 2
}

export enum SoilHumidity {
  WET = 0,
  DRY = 1,
  MOIST = 2,
  UNKNOWN = 'UNKNOWN'
}

export enum WindDirectionOptions {
  SOUTH = 'SOUTH',
  SOUTH_EAST = 'SOUTHEAST',
  SOUTH_WEST = 'SOUTHWEST',
  NORTH = 'NORTH',
  NORTH_EAST = 'NORTHEAST',
  NORTH_WEST = 'NORTHWEST',
  EAST = 'EAST',
  WEST = 'WEST'
}

export enum TaskType {
  Monitoring = 'PHENOMENON_MONITORING',
  Spray = 'SPRAY',
  Sample = 'SAMPLE',
  Application = 'APPLICATION',
  Trap = 'TRAP',
  PostHarvest = 'POST_HARVEST'
}

export enum TaskStatus {
  TODO = 'TODO',
  IN_PROGRESS = 'IN_PROGRESS',
  DELAYED = 'DELAYED',
  DONE = 'DONE'
}

export enum MonitoringType {
  AUTO = 'AUTO',
  AUTO_BY_AREA = 'AUTO_BY_AREA',
  AUTO_SAMPLE_COUNT = 'AUTO_SAMPLE_COUNT',
  FREE = 'FREE',
  FREE_BY_AREA = 'FREE_BY_AREA',
  FREE_SAMPLE_COUNT = 'FREE_SAMPLE_COUNT',
  MARKED = 'MARKED',
  YIELD_ESTIMATION = 'YIELD_ESTIMATION'
}

export enum TrapTaskType {
  INSTALLATION = 'INSTALLATION',
  MONITORING = 'MONITORING',
  RENEW = 'RENEW',
  UNINSTALLATION = 'UNINSTALLATION',
  REINSTALLATION = 'REINSTALLATION'
}
